@if (finishBlockModal.configuratedOptions) {
  <div class="common-modal__container">
    <!-- Cabecera -->
    <div class="common-modal__header">
      <span class="common-modal__text-header">{{finishBlockModal.configurationModal.title}}</span>
    </div>
    <!-- Contenedor -->
    <div class="common-modal__content">
      <p class="common-modal__content-header-info">{{finishBlockModal.configurationModal.info}}</p>
      <div class="finish-block-modal__body-container">
        @for (option of finishBlockModal.configurationModal.options; track $index) {
          @if (configuration.from === 'innerEvaluation') {
            <div class="common-decision-card__container"
              [ngClass]="{'common-decision-card__container--error': option.error }">
              <div class="common-decision-card__header"
                [ngClass]="{'common-decision-card__header--error': option.error }">
                <span class="common-decision-card__title"
                  [afTranslate]="option.title">Bloquear datos
                </span>
                <i [class]="option.icon + ' common-icon__xl'"></i>
              </div>
              <div class="common-button__body-decision-button">
                <button (click)="selectOption(true, option)"
                  class="common-button__decision-button"
                  [disabled]="option.noEditable"
                  [ngClass]="{'common-button__decision-button--selected': option.selected}">
                  <span class="common-button__decision-button-label-text"
                    [afTranslate]="'common.yes'">Si
                  </span>
                </button>
                <button (click)="selectOption(false, option)"
                  class="common-button__decision-button"
                  [disabled]="option.noEditable"
                  [ngClass]="{'common-button__decision-button--selected': !option.selected }">
                  <span class="common-button__decision-button-label-text"
                    [afTranslate]="'common.no'">No
                  </span>
                </button>
              </div>
              @if (option.showInfoCalendar && finishBlockModal.dateAlert) {
                <div class="common-decision-card__date-info">
                  <span [afTranslate]="'finish-block-modal.scheduled-alert'">_Alerta programada</span>
                  <span>:</span>
                  <span class="common-decision-card__date-detail">
                    {{finishBlockModal.dateAlert | convertDate:'without-time'}}
                  </span>
                </div>
              }
              <span class="common-decision-card__description">
                {{option.selected?option.infoSelected:option.infoNoSelected}}
              </span>
              @if (option.showInfoCalendar) {
                <div class="common-decision-card__button-container">
                  <button class="common-button__text-noborder"
                    (click)="openCalendar(option)">
                    <span class="common-button__text-title"
                      [afTranslate]="finishBlockModal.dateAlert?'finish-block-modal.modify-date':'finish-block-modal.select-date'">Seleccionar fecha</span>
                  </button>
                  @if (option.selected && !finishBlockModal.dateAlert) {
                    <div class="common-tag__mandatory-obligatory-message">
                      <span class="common-tag__mandatory-text-asterisk">*</span>
                      <span class="common-tag__mandatory-label-text-obligatory"
                        [ngClass]="{'common-tag__mandatory-label-text-obligatory--error': option.error}">
                        (<span class="lowercase" [afTranslate]="'customize.required'">obligatorio</span>)
                      </span>
                    </div>
                  }
                </div>
              }
              @if (option.showAdditionalInfo) {
                <div class="common-status-message__s-container-warning">
                  <span-tooltip class="common-status-message__s-title"
                    [text]="option.textAdditionalInfo">
                  </span-tooltip>
                </div>
              }
            </div>
          }@else {
            <div class="common-information-card__container">
              <div class="common-decision-card__header">
                <span class="common-decision-card__title"
                  [afTranslate]="option.title">_Bloquear edición
                </span>
                <i [class]="option.icon + ' common-icon__xl'"></i>
              </div>
              <span class="common-decision-card__description">
                {{option.selected?option.infoSelected:option.infoNoSelected}}
              </span>
            </div>
          }
        }

      </div>
    </div>
    <!-- Footer botonera -->
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="validateConfiguration()">
        <span class="common-button__text-title"
          [afTranslate]="'common.execute'">_Ejecutar</span>
      </button>
    </div>
  </div>
}
